import { useMutation } from '@tanstack/react-query';
import type {
  DbaComplimentaryBody,
  DbaGrantCreditBody,
  DbaHubInviteBody,
  DbaSetDiscountBody,
} from '@vivport/backend/types/dba';

import {
  activateComplimentary,
  endComplimentary,
  grantCredit,
  inviteHubMember,
  provisionAccount,
  removeDiscount,
  resendInvite,
  setDiscount,
} from '@/api/dba-api';
import { useInvalidateDba } from './use-invalidate-dba';

export function useSetDiscount() {
  const invalidate = useInvalidateDba();
  return useMutation({
    mutationFn: ({ email, body }: { email: string; body: DbaSetDiscountBody }) => setDiscount(email, body),
    onSuccess: invalidate,
  });
}

export function useRemoveDiscount() {
  const invalidate = useInvalidateDba();
  return useMutation({ mutationFn: removeDiscount, onSuccess: invalidate });
}

export function useActivateComplimentary() {
  const invalidate = useInvalidateDba();
  return useMutation({
    mutationFn: ({ accountId, body }: { accountId: number; body: DbaComplimentaryBody }) =>
      activateComplimentary(accountId, body),
    onSuccess: invalidate,
  });
}

export function useEndComplimentary() {
  const invalidate = useInvalidateDba();
  return useMutation({
    mutationFn: ({ accountId, body }: { accountId: number; body: DbaComplimentaryBody }) =>
      endComplimentary(accountId, body),
    onSuccess: invalidate,
  });
}

export function useGrantCredit() {
  const invalidate = useInvalidateDba();
  return useMutation({
    mutationFn: ({ accountId, body }: { accountId: number; body: DbaGrantCreditBody }) => grantCredit(accountId, body),
    onSuccess: invalidate,
  });
}

export function useProvisionAccount() {
  const invalidate = useInvalidateDba();
  return useMutation({ mutationFn: provisionAccount, onSuccess: invalidate });
}

export function useInviteHubMember() {
  const invalidate = useInvalidateDba();
  return useMutation({
    mutationFn: ({ hubId, body }: { hubId: number; body: DbaHubInviteBody }) => inviteHubMember(hubId, body),
    onSuccess: invalidate,
  });
}

export function useResendInvite() {
  const invalidate = useInvalidateDba();
  return useMutation({ mutationFn: resendInvite, onSuccess: invalidate });
}
